var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScooterDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26365 8.88467C4.42652 8.88467 4.55856 8.74544 4.55856 8.57368C4.55856 8.40193 4.42652 8.2627 4.26365 8.2627C4.10078 8.2627 3.96875 8.40193 3.96875 8.57368C3.96875 8.74544 4.10078 8.88467 4.26365 8.88467Z",
    fill: "#6D26E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9199 4.81241C14.0828 4.81241 14.2148 4.67317 14.2148 4.50142C14.2148 4.32966 14.0828 4.19043 13.9199 4.19043C13.757 4.19043 13.625 4.32966 13.625 4.50142C13.625 4.67317 13.757 4.81241 13.9199 4.81241Z",
    fill: "#6D26E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95512 9.14423H5.96484V6.23535H8.21765",
    fill: "#6D26E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95512 9.14423H5.96484V6.23535H8.21765",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1392 7.24219V9.14401H10.4922",
    fill: "#6D26E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1392 7.24219V9.14401H10.4922",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2953 8.88185C10.8144 10.1487 11.4407 11.6694 11.4677 11.6995L11.0435 16.0546L11.0339 16.0481C10.2109 15.4901 10.0387 13.899 10.1349 12.8722L10.2079 12.0943L8.73293 9.93518C8.73293 9.93518 7.24241 11.1196 7.15787 11.1699L2.09766 13.2039C2.25373 12.52 2.33643 12.0832 2.94948 11.806L6.41318 10.0948L7.81832 7.90039",
    fill: "#6D26E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2953 8.88185C10.8144 10.1487 11.4407 11.6694 11.4677 11.6995L11.0435 16.0546L11.0339 16.0481C10.2109 15.4901 10.0387 13.899 10.1349 12.8722L10.2079 12.0943L8.73293 9.93518C8.73293 9.93518 7.24241 11.1196 7.15787 11.1699L2.09766 13.2039C2.25373 12.52 2.33643 12.0832 2.94948 11.806L6.41318 10.0948L7.81832 7.90039",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2049 1C11.4976 1 11.7782 1.12259 11.9851 1.3408C12.1921 1.559 12.3083 1.85496 12.3083 2.16355V3.90888H11.2054C11.0604 3.90888 10.9169 3.87877 10.783 3.82027C10.6491 3.76177 10.5274 3.67603 10.4249 3.56794C10.3224 3.45985 10.2411 3.33152 10.1856 3.19029C10.1301 3.04907 10.1016 2.8977 10.1016 2.74483V2.16355C10.1016 1.85496 10.2178 1.559 10.4247 1.3408C10.6317 1.12259 10.9123 1 11.2049 1Z",
    fill: "#6D26E1",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.793 7.10938H16.448",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85547 16.1259H13.9655C13.9655 15.663 14.1399 15.2191 14.4503 14.8917C14.7607 14.5644 15.1816 14.3806 15.6206 14.3806L15.6133 7.20312",
    fill: "#6D26E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85547 16.1259H13.9655C13.9655 15.663 14.1399 15.2191 14.4503 14.8917C14.7607 14.5644 15.1816 14.3806 15.6206 14.3806L15.6133 7.20312",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79237 16.9983C7.2494 16.9983 7.6199 16.6076 7.6199 16.1256C7.6199 15.6436 7.2494 15.2529 6.79237 15.2529C6.33534 15.2529 5.96484 15.6436 5.96484 16.1256C5.96484 16.6076 6.33534 16.9983 6.79237 16.9983Z",
    fill: "#6D26E1",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8978 16.9983C16.3549 16.9983 16.7254 16.6076 16.7254 16.1256C16.7254 15.6436 16.3549 15.2529 15.8978 15.2529C15.4408 15.2529 15.0703 15.6436 15.0703 16.1256C15.0703 16.6076 15.4408 16.9983 15.8978 16.9983Z",
    fill: "#6D26E1",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4314 5.57605L12.039 7.05795C12.0975 7.11214 12.1661 7.15266 12.2405 7.17687C12.3149 7.20107 12.3932 7.20839 12.4705 7.19836L14.239 7.10793H14.9286C15.0384 7.10793 15.1436 7.06196 15.2212 6.98013C15.2988 6.8983 15.3424 6.78732 15.3424 6.67159C15.3424 6.55587 15.2988 6.44489 15.2212 6.36306C15.1436 6.28123 15.0384 6.23526 14.9286 6.23526H14.239L12.5812 6.01166L11.0689 4.07618L10.5761 3.69953C10.4605 3.63825 10.3345 3.60158 10.2055 3.59163C10.0764 3.58168 9.94673 3.59864 9.82387 3.64154C9.70101 3.68443 9.58737 3.75243 9.48943 3.84165C9.39149 3.93086 9.31117 4.03954 9.25306 4.16149L7.84547 7.11561C7.78481 7.25094 7.75353 7.39884 7.75391 7.54853C7.75428 7.69822 7.7863 7.84593 7.84763 7.98093C7.90896 8.11593 7.99806 8.23481 8.10845 8.32892C8.21884 8.42303 8.34773 8.49 8.48575 8.52496L9.72632 8.8653C9.90014 8.91776 10.0861 8.90192 10.2497 8.82072C10.4133 8.73951 10.5433 8.59846 10.6157 8.42376L11.345 6.56178",
    fill: "#6D26E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4314 5.57605L12.039 7.05795C12.0975 7.11214 12.1661 7.15266 12.2405 7.17687C12.3149 7.20107 12.3932 7.20839 12.4705 7.19836L14.239 7.10793H14.9286C15.0384 7.10793 15.1436 7.06196 15.2212 6.98013C15.2988 6.8983 15.3424 6.78732 15.3424 6.67159C15.3424 6.55587 15.2988 6.44489 15.2212 6.36306C15.1436 6.28123 15.0384 6.23526 14.9286 6.23526H14.239L12.5812 6.01166L11.0689 4.07618L10.5761 3.69953C10.4605 3.63825 10.3345 3.60158 10.2055 3.59163C10.0764 3.58168 9.94673 3.59864 9.82387 3.64154C9.70101 3.68443 9.58737 3.75243 9.48943 3.84165C9.39149 3.93086 9.31117 4.03954 9.25306 4.16149L7.84547 7.11561C7.78481 7.25094 7.75353 7.39884 7.75391 7.54853C7.75428 7.69822 7.7863 7.84593 7.84763 7.98093C7.90896 8.11593 7.99806 8.23481 8.10845 8.32892C8.21884 8.42303 8.34773 8.49 8.48575 8.52496L9.72632 8.8653C9.90014 8.91776 10.0861 8.90192 10.2497 8.82072C10.4133 8.73951 10.5433 8.59846 10.6157 8.42376L11.345 6.56178",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44682 2.74609H5.13672",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69111 4.2002H3.48438",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03396 2.74609H2.37891",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 6.23535H4.86058",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0018 16.999H1.55469",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10337 6.23535H1",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2422 6.23535V7.10802",
    stroke: "#6D26E1",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScooterDelivery);
export default __webpack_public_path__ + "static/media/scooterDelivery.2c3e63415192dbdbe66b8218841ff1cb.svg";
export { ForwardRef as ReactComponent };